import React, { useState } from "react";
import { FaMinus, FaPlus } from "react-icons/fa";

const FAQSection = ({ faqs }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // Convert faqs object into an array of category objects
  const faqArray = Object.entries(faqs).map(([category, questions]) => ({
    category,
    questions,
  }));

  return (
    <section
      className="bg-[#f7faff] py-16 px-4 sm:px-6 lg:px-12"
      style={{
        backgroundImage: `url(/background3.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container mx-auto flex flex-col lg:flex-row gap-12">
        {/* Sticky Image Section */}
        <div className="lg:w-1/3 hidden lg:block">
          <div className="sticky top-20">
            <img
              src="/faq_10_1.png.png"
              alt="Woman holding a laptop"
              className="rounded-lg w-full max-w-sm lg:max-w-md "
            />
          </div>
        </div>

        {/* FAQ Section */}
        <div className="lg:w-2/3 w-full">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-custom-blue text-center lg:text-left mb-10">
            Frequently Asked Questions
          </h2>

          {/* Render each category */}
          <div className="space-y-8">
            {faqArray.map((faqCategory, catIndex) => (
              <div key={catIndex} className="p-6">
                {/* Category Title */}
                <h3 className="text-xl md:text-2xl font-semibold text-custom-blue mb-4">
                  {faqCategory.category}
                </h3>

                {/* Questions */}
                <div className="space-y-4">
                  {faqCategory.questions.map((faq, index) => (
                    <div
                      key={index}
                      className="border rounded-lg overflow-hidden shadow"
                    >
                      <button
                        className={`flex justify-between items-center w-full px-5 py-4 text-left transition-all ${
                          activeIndex === `${catIndex}-${index}`
                            ? "bg-custom-gradient text-white"
                            : "bg-white text-gray-800 hover:bg-gray-100"
                        }`}
                        onClick={() => toggleFAQ(`${catIndex}-${index}`)}
                      >
                        <span className="text-lg sm:text-xl font-medium">
                          {faq.question}
                        </span>
                        {activeIndex === `${catIndex}-${index}` ? (
                          <FaMinus className="text-lg text-white" />
                        ) : (
                          <FaPlus className="text-lg text-gray-700" />
                        )}
                      </button>
                      <div
                        className={`transition-all duration-300 ease-in-out overflow-hidden ${
                          activeIndex === `${catIndex}-${index}`
                            ? "max-h-40 p-4 bg-white text-gray-600"
                            : "max-h-0"
                        }`}
                      >
                        {faq.answer}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
